import React, { useState } from "react";
import NewPasswordForm from "../molecules/NewPasswordForm";
import ResetPasswordSuccess from "./ResetPasswordSuccess";
import AuthLayout from "./AuthLayout";

const NewPassword = () => {
  const [isPasswordReset, setIsPasswordReset] = useState(false);

  return (
    <AuthLayout logoClickable>
      {isPasswordReset
        ? <ResetPasswordSuccess dark />
        : <NewPasswordForm setIsPasswordReset={setIsPasswordReset} dark />
      }
    </AuthLayout>
  );
};

export default NewPassword;
